import { trace } from '@opentelemetry/api';
import { WebTracerProvider, SimpleSpanProcessor } from '@opentelemetry/sdk-trace-web';
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { getUserIdFromCookie, getDeviceId } from './handlingCookies';
import {getCurrentUrl, getPageTitle, countryValue} from './interactiveUserEvents';
import { username, password, url } from './constant';
import { bp_product_id, env } from './constant';

const provider = new WebTracerProvider();
trace.setGlobalTracerProvider(provider);

const authHeader = `Basic ${btoa(`${username}:${password}`)}`;
const initializeExporter = () => {
const otlpExporter = new OTLPTraceExporter({
endpoint: url,
url: `${url}/v1/traces`,
headers: { Authorization: authHeader },
});
return otlpExporter;
};
console.log(authHeader);
const otlpExporter = initializeExporter();

  provider.addSpanProcessor(new SimpleSpanProcessor(otlpExporter));
  export const tracer = provider.getTracer('product-analytics-trace');
  export const RouteChangesListener = () => {
   const handleRouteChange = () => {
      console.log('RouteChangeListener effect started');
      const uuid= getUserIdFromCookie();
      const install_id= getDeviceId();
      const span = tracer.startSpan('route-change', {});
    
      span.addEvent('change', {
        schema: 'iglu:com.bp.jssdk/route_change/jsonschema/1-0-2',
        country: countryValue,
        routePath: window.location.pathname,
        URL: getCurrentUrl(),
        title: getPageTitle(),
        uuid,
        loggedin_id: uuid,
        install_id,
        bp_product_id,
        env,
      });
  
      span.end();
  
      console.log('RouteChangeListener effect cleanup');
    };
  
    window.addEventListener('popstate', handleRouteChange);
  
    // Return a function that removes the event listener
    return () => {
        window.removeEventListener('popstate', handleRouteChange);
        console.log('RouteChangeListener cleanup');
      };
    };
 

export const addEventListenerWithTelemetry = (selector, eventName, handler) => {
  console.log(username);
    console.log('Tracer:', tracer);
    console.log('Event listener added for', eventName);

    const eventHandler = (event) => {
        console.log('Event handler triggered for', eventName);

        const span = tracer.startSpan(eventName, {});

        const properties = handler(event);
        properties.uuid = getUserIdFromCookie();
        properties.loggedin_id= properties.uuid;
        properties.install_id= getDeviceId();
        if (properties) {
            span.addEvent(`${eventName}-event`, properties
            );
            console.log(`${eventName}-event`, 
                 properties
                )
        }

        span.end();
        console.log('Span ended');
    };

    const elements =
    selector instanceof Window || selector === window
      ? [window]
      : selector instanceof Document || selector === document
      ? [document]
      : Array.from(document.querySelectorAll(selector));

  elements.forEach((element) => {
    element.addEventListener(eventName, eventHandler);
  });

  return () => {
    elements.forEach((element) => {
      element.removeEventListener(eventName, eventHandler);
    });
    
  }
  
};
